import Crud from '@/views/CheckScheduleDeviation/Crud'
import Approvals from '@/views/CheckScheduleDeviation/Approvals'

const routes = {
  path: '/check-schedule-deviations',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/check-schedule-deviations',
      name: 'list-check-schedule-deviations',
      component: Crud,
    },
    {
      path: '/check-schedule-deviations/approvals',
      name: 'approvals-check-schedule-deviations',
      component: Approvals,
    },
  ],
}

export default routes
